export const APP_NAME = "Q-Vanguard Platform";

export const ROUTES = {
  HOME: "/home",
  LOGIN: "/login",
  REGISTER: "/register",
  REGISTER_COMPANY: "/register/company",
  REGISTER_PRIVATE: "/register/student",
  REGISTER_PROFESSIONAL: "/register/professional",
  TOPOLOGY: "/topology",
};

export const USER_ROLES = {
  COMPANY_ADMIN: "company_admin",
  PRIVATE_USER: "private_user",
};
